import { Tooltip } from "primereact/tooltip";

const BaseTooltip = (props) => {
    return (
        <Tooltip {...props} className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`}/>
    );
};

export default BaseTooltip;
